import { createGlobalStyle } from 'styled-components'
import theme from './theme'

const GlobalStyle = createGlobalStyle`

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    position: relative;
  }

  html,
  body {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  html {
    font-family: ${theme.fonts.sans};
    font-size: 6px;
    ${({ theme: { mediaQueries: { small } } }) => small} {
      font-size: 6px;
    }
    ${({ theme: { mediaQueries: { large } } }) => large} {
      font-size: 8px;
    }
  }

  body {
    font-size: ${theme.fontSizes[3]};
  }

  .contentButton {
    div {
      &::before {
        content: "";
      }
    }
  }

  a {
    color: white;
    display: block;
    position: relative;
    text-decoration: none;
    &:hover {
      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 55%;
        left: 0;
        bottom: 10%;
        z-index: 0;
        background: radial-gradient(45.4% 446.95% at 44.74% 31.82%, rgba(245, 51, 63, 0.87) 15.37%, rgba(245, 51, 63, 0.56) 63.24%, rgba(245, 51, 63, 0) 100%);
      }
    }
  }

  b, strong {
    font-weight: 900;
  }

  li {
    margin-left: 2em;
  }

  p, ul, ol {
    margin-bottom: 1em;
  }

  input {
    -webkit-writing-mode: horizontal-tb !important;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    line-height: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    appearance: auto;
    -webkit-rtl-ordering: logical;
    cursor: text;
    margin: 0em;
    border: 0;
  }

  :focus-visible {
    outline: none;
  }

  input:focus-visible {
    outline-offset: 0px;
  }


`
export default GlobalStyle
